export default __webpack_public_path__ + "static/media/cart_icon.91c8b542.svg";